import type { TenantSimpleDTO } from "@/api/_orval/oa";

export type State = {
	apiUserId?: string;
	apiAccessToken?: string;
	apiRefreshToken?: string;
	bwAccessToken?: string;
	bwRefreshToken?: string;
	bwAuthScheme?: string;
	bwUserId?: number;
	bwTenantId?: number;
	bwDepartmentId?: number;
	bwPermissions: string[];
	bwUsername?: string | null;
	bwNickname?: string | null;
	bwTenants?: TenantSimpleDTO[];
};

export type Action = {
	setApiUserId: (e: State["apiUserId"]) => void;
	setApiAccessToken: (e: State["apiAccessToken"]) => void;
	setApiRefreshToken: (e: State["apiRefreshToken"]) => void;
	SET_BW_ACCESS_TOKEN: (token: State["bwAccessToken"]) => void;
	SET_BW_REFRESH_TOKEN: (token: State["bwRefreshToken"]) => void;
	SET_BW_USER_ID: (id: State["bwUserId"]) => void;
	SET_BW_AUTH_SCHEME: (token: State["bwAuthScheme"]) => void;
	SET_BW_TENANT_ID: (token: State["bwTenantId"]) => void;
	SET_BW_DEPARTMENT_ID: (token: State["bwDepartmentId"]) => void;
	SET_BW_PERMISSIONS: (permissions: State["bwPermissions"]) => void;
	RESET: () => void;
	setBwUsername: (e: State["bwUsername"]) => void;
	setBwNickname: (e: State["bwNickname"]) => void;
	setBwTenants: (e: State["bwTenants"]) => void;
	update: (e: Partial<State>) => void;
};

export const getInitialState = (): State => {
	return {
		apiUserId: undefined,
		apiAccessToken: undefined,
		apiRefreshToken: undefined,
		bwAccessToken: undefined,
		bwRefreshToken: undefined,
		bwAuthScheme: undefined,
		bwUserId: undefined,
		bwTenantId: undefined,
		bwDepartmentId: undefined,
		bwPermissions: [],
		bwUsername: null,
		bwNickname: null,
		bwTenants: [],
	};
};

export const getInitialAction = (set: any): Action => {
	return {
		setApiUserId: (apiUserId) => {
			set(() => ({
				apiUserId,
			}));
		},
		setApiAccessToken: (apiAccessToken) => {
			set(() => ({
				apiAccessToken,
			}));
		},
		setApiRefreshToken: (apiRefreshToken) => {
			set(() => ({
				apiRefreshToken,
			}));
		},
		SET_BW_ACCESS_TOKEN: (accessToken) => {
			set(() => ({ bwAccessToken: accessToken }));
		},
		SET_BW_REFRESH_TOKEN: (refreshToken) => {
			set(() => ({ bwRefreshToken: refreshToken }));
		},
		SET_BW_AUTH_SCHEME: (authScheme) => {
			set(() => ({ bwAuthScheme: authScheme }));
		},
		SET_BW_USER_ID: (userId) => {
			set(() => ({ bwUserId: userId }));
		},
		SET_BW_TENANT_ID: (tenantId) => {
			set(() => ({ bwTenantId: tenantId }));
		},
		SET_BW_DEPARTMENT_ID: (departmentId) => {
			set(() => ({ bwDepartmentId: departmentId }));
		},
		SET_BW_PERMISSIONS: (permissions) => {
			set(() => ({ bwPermissions: permissions }));
		},
		RESET: () => {
			set(getInitialState());
		},
		setBwUsername: (bwUsername) => {
			set(() => ({ bwUsername }));
		},
		setBwNickname: (bwNickname) => {
			set(() => ({ bwNickname }));
		},
		setBwTenants: (bwTenants) => {
			return set(() => ({
				bwTenants,
			}));
		},
		update: (state) => {
			set(() => state);
		},
	};
};

export const storeName = "store:user";

export type PersistedState = Pick<
	State,
	| "apiAccessToken"
	| "apiRefreshToken"
	| "bwAccessToken"
	| "bwRefreshToken"
	| "bwTenantId"
>;

export const partialize = (state: State & Action): PersistedState => {
	const {
		apiAccessToken,
		apiRefreshToken,
		bwAccessToken,
		bwRefreshToken,
		bwTenantId,
	} = state;
	return {
		apiAccessToken,
		apiRefreshToken,
		bwAccessToken,
		bwRefreshToken,
		bwTenantId,
	};
};
